import { createTheme } from "@mui/material/styles";
export var FontWeightVariants = {
    normal: {
        fontFamily: 'NotoSans-Regular'
        // fontWeight: 400,
    },
    medium: {
        fontFamily: 'NotoSans-Medium'
        // fontWeight: 500,
    },
    strong: {
        fontFamily: 'NotoSans-Semibold'
        // fontWeight: 600,
    }
};
export var FontSizeVariants = {
    xs: {
        fontSize: '10px',
        lineHeight: '16px'
    },
    sm: {
        fontSize: '12px',
        lineHeight: '18px'
    },
    lg: {
        fontSize: '16px',
        lineHeight: '24px'
    },
    xl: {
        fontSize: '18px',
        lineHeight: '28px'
    },
    xxl: {
        fontSize: '20px',
        lineHeight: '28px'
    },
    base: {
        fontSize: '14px',
        lineHeight: '20px'
    }
};
var theme = createTheme();
var typography = function (palette) {
    var _a, _b;
    return ({
        fontFamily: "NotoSans-Regular",
        fontWeightBold: 600,
        fontWeightMedium: 500,
        fontWeightRegular: 400,
        fontSize: 14,
        allVariants: {
            wordWrap: "break-word"
        },
        h1: {
            fontSize: "20px",
            fontFamily: 'NotoSans-SemiBold'
        },
        h2: {
            fontSize: "18px",
            fontFamily: 'NotoSans-Medium'
        },
        h3: {
            fontSize: "16px",
            fontFamily: 'NotoSans-Medium'
        },
        h4: {
            fontSize: "16px"
        },
        h5: (_a = {
                fontSize: "14px",
                fontFamily: 'NotoSans-SemiBold'
            },
            _a[theme.breakpoints.down('sm')] = {
                fontSize: '12px'
            },
            _a.wordWrap = "break-word",
            _a),
        h6: (_b = {
                fontSize: "14px",
                fontFamily: 'NotoSans-Regular'
            },
            _b[theme.breakpoints.down('sm')] = {
                fontSize: '12px'
            },
            _b.wordWrap = "break-word",
            _b),
        subtitle1: {
            fontSize: "12px",
            fontFamily: 'NotoSans-SemiBold',
            // [theme.breakpoints.down('md')]: {
            //   fontSize: '10px',
            // },
            wordWrap: "break-word"
        },
        subtitle2: {
            fontSize: "12px",
            fontFamily: 'NotoSans-Medium'
            // [theme.breakpoints.down('sm')]: {
            //   fontSize: '10px',
            // },
        },
        body1: {
            fontSize: '14px'
        },
        body2: {
            fontSize: "16px",
            // fontWeight: 400,
            // [theme.breakpoints.down('md')]: {
            //   fontSize: '16px',
            // },
            wordWrap: "break-word"
        },
        caption: {
            fontSize: "12px"
        }
    });
};
export default typography;
